import { render, staticRenderFns } from "./Detail-Bills.vue?vue&type=template&id=77906a02&scoped=true"
import script from "./Detail-Bills.vue?vue&type=script&lang=js"
export * from "./Detail-Bills.vue?vue&type=script&lang=js"
import style0 from "./Detail-Bills.vue?vue&type=style&index=0&id=77906a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77906a02",
  null
  
)

export default component.exports